module.exports = __webpack_public_path__ + "static/media/cameraIcon.e3d53a01.png";